<template>
    <div class="page" :style="{'--styleColor': actInfo.color, backgroundImage:'url('+ actInfo.bg_reg +')'}">
        <PageLoading v-if="loading || loadForm"></PageLoading>
        <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
        <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
        <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>
        <div class="mainBox">
          
          <van-cell-group>
              <van-form @submit="onSubmit">

                <!-- 固定登记项：仅当未配置自定义表单时展示 -->
                <template v-if="formFields.length === 0">
                <van-field v-model="person_name" name="person_name" label="" placeholder="请输入姓名" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('xm'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="renwu-ren" size="20"></van-icon>
                </van-field>

                <van-field v-model="idcard" name="idcard" type="text" label="" placeholder="请输入身份证号" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('sfzh'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zhengjian" size="20"></van-icon>
                </van-field>

                <van-field v-model="contact" name="contact" type="text" label="" placeholder="请输入联系电话" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dh'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="shiwu-shoujidefuben" size="20"></van-icon>
                </van-field>

                <van-field v-model="area_name" name="area_name" is-link readonly placeholder="请选择所在地区" @click="showSelect = true" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="gongsiqiye1" size="20"></van-icon>
                </van-field>

                <van-popup v-model="showSelect" round position="bottom" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))"> 
                  <van-cascader
                    v-model="areaid"
                    title="请选择所属组织"
                    :options="options"
                    :field-names="fieldNames"
                    @close="showSelect = false"
                    @finish="onFinish"
                  />
                </van-popup>

                <van-field v-model="areaid" name="areaid" type="hidden"  style="display:none;" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dq'))">
                </van-field>              
                
                <van-field v-model="company" name="company" label="" placeholder="请输入所在单位" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dw'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="zixun" size="20"></van-icon>
                </van-field>

                 <van-field v-model="address" name="address" label="" placeholder="请输入详细地址" :rules="[{ required: true, message: '' }]" v-if="actInfo.dis_reg && (actInfo.dis_reg.includes('dz'))">
                  <van-icon class="huodong" class-prefix="icon" slot="left-icon" name="dingwei1" size="20"></van-icon>
                </van-field>               
                </template>

              <!-- 自定义登记表单（新活动） -->
              <template v-if="formFields.length > 0">
                <template v-for="(f, fi) in formFields">

                  <!-- 文本框 -->
                  <van-field
                    v-if="f.type === 'text'"
                    v-model="formData[f.model]"
                    :name="f.model"
                    :label="f.icon ? '' : f.label"
                    :placeholder="f.placeholder || ('请输入' + f.label)"
                    :maxlength="f.max_length > 0 ? f.max_length : undefined"
                    :rules="f.required ? [{ required: true, message: '' }] : []"
                  >
                    <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                  </van-field>

                  <!-- 单选 -->
                  <template v-if="f.type === 'radio'">
                    <!-- 单选按钮 -->
                    <van-field
                      v-if="f.display_type !== 'select' && f.display_type !== 'index'"
                      :name="f.model"
                      :label="f.icon ? '' : f.label"
                      :rules="f.required ? [{ required: true, message: '' }] : []"
                    >
                      <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                      <template #input>
                        <van-radio-group v-model="formData[f.model]" direction="horizontal" icon-size="16">
                          <van-radio v-for="opt in f.options" :key="opt.value" :name="opt.value">{{ opt.label }}</van-radio>
                        </van-radio-group>
                      </template>
                    </van-field>

                    <!-- 下拉框 -->
                    <template v-else-if="f.display_type === 'select'">
                      <van-field
                        v-model="radioText[f.model]"
                        :name="f.model"
                        :label="f.icon ? '' : f.label"
                        is-link
                        readonly
                        :placeholder="f.placeholder || ('请选择' + f.label)"
                        :rules="f.required ? [{ required: true, message: '' }] : []"
                        @click="radioShow[f.model] = true"
                      >
                        <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                      </van-field>
                      <van-popup v-model="radioShow[f.model]" round position="bottom">
                        <van-picker
                          v-if="radioShow[f.model]"
                          show-toolbar
                          :columns="f.options"
                          value-key="label"
                          :default-index="optionIndex(f)"
                          :title="'请选择' + f.label"
                          @confirm="(val, idx) => onRadioConfirm(f, idx)"
                          @cancel="radioShow[f.model] = false"
                        />
                      </van-popup>
                    </template>

                    <!-- 首字母索引 -->
                    <template v-else>
                      <van-field
                        v-model="radioText[f.model]"
                        :name="f.model"
                        :label="f.icon ? '' : f.label"
                        is-link
                        readonly
                        :placeholder="f.placeholder || ('请选择' + f.label)"
                        :rules="f.required ? [{ required: true, message: '' }] : []"
                        @click="radioShow[f.model] = true"
                      >
                        <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                      </van-field>
                      <van-popup v-model="radioShow[f.model]" closeable round position="bottom" :style="{ height: '80%' }" class="areaBox">
                        <div class="indexBody">
                          <van-index-bar highlight-color="#1989fa" :index-list="radioIndexData(f).indexList">
                            <div v-for="grp in radioIndexData(f).filterData" :key="grp.letter">
                              <van-index-anchor :index="grp.letter"></van-index-anchor>
                              <van-cell v-for="opt in grp.list" :key="opt.value" :title="opt.label" @click="onRadioIndexSelect(f, opt)" />
                            </div>
                          </van-index-bar>
                        </div>
                      </van-popup>
                    </template>
                  </template>

                  <!-- 多选 -->
                  <van-field
                    v-if="f.type === 'checkbox'"
                    :name="f.model"
                    :label="f.icon ? '' : f.label"
                    :rules="f.required ? [{ required: true, message: '' }] : []"
                  >
                    <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                    <template #input>
                      <van-checkbox-group v-model="formData[f.model]" direction="horizontal">
                        <van-checkbox v-for="opt in f.options" :key="opt.value" :name="opt.value">{{ opt.label }}</van-checkbox>
                      </van-checkbox-group>
                    </template>
                  </van-field>

                  <!-- 地区联动 -->
                  <template v-if="f.type === 'region'">
                    <van-field
                      v-model="regionText[f.model]"
                      :name="f.model"
                      :label="f.icon ? '' : f.label"
                      is-link
                      readonly
                      :placeholder="f.placeholder || ('请选择' + f.label)"
                      :rules="f.required ? [{ required: true, message: '' }] : []"
                      @click="regionShow[f.model] = true"
                    >
                      <van-icon v-if="f.icon" class="huodong" class-prefix="icon" slot="left-icon" :name="f.icon" size="20"></van-icon>
                    </van-field>
                    <van-popup v-model="regionShow[f.model]" round position="bottom">
                      <van-cascader
                        v-model="formData[f.model]"
                        :title="'请选择' + f.label"
                        :options="regionOptions[f.model] || []"
                        @close="regionShow[f.model] = false"
                        @finish="onRegionFinish(f, $event)"
                      />
                    </van-popup>
                  </template>

                </template>
              </template>

              <div class="subBtn">
                <van-button round block type="info" native-type="submit">保存信息</van-button>
              </div>

            </van-form>
          </van-cell-group>
        
        </div>

        <!-- <div class="navBox">
          <div class="navTxt" @click="toHome"><i class="huodong icon-zhuye"></i>首页</div>
          <div class="navTxt" @click="toMyCenter"><i class="huodong icon-wode1"></i>个人中心</div>
        </div> -->
    </div>


    
</template>

<script>

import {reqUserAdd, reqLearnInfo, reqRegion} from '@/api/learn.js' //动态接口
import {reqArea} from '@/api/index2.js' //静态接口
import Cookies from 'js-cookie'
import zonglan from '@/utils/cp-zonglan.js'
import PageLoading from '@/components/PageLoading.vue'
import TipsWechat from '@/components/TipsWechat.vue'
import TipsZonglan from '@/components/TipsZonglan.vue'
import TipsHbrb from '@/components/TipsHbrb.vue'
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'

export default {
  mixins: [],
  components: { PageLoading, TipsWechat, TipsZonglan, TipsHbrb },
  props: {},
  data () {
    return {
      platform:0, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
      loading:false,
      loadForm:false,
      learnid:0,
      token:"",
      actInfo:"",
      title:"",
      shareTitle:"",
      shareDesc:"",      
      showNotice:false,
      showKefu:false,
      person_name:'',      
      idcard:'',
      contact:'',
      address:'',
      company:'',
      showSelect: false,      
      areaid: '',
      area_name: '',
      fieldNames: {
        text: 'region_name',
        value: 'region_id',
        children: 'children',
      },
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [
        {
          text: '省政府有关部门',
          value: '1',
          children: [
            { 
              text: '河北省发展和改革委员会', 
              value: '3',
              children:[
                { text:'石家庄',value:'8'}
              ]
            },
            { text: '河北省人力资源和社会保障厅', value: '4' },
            { text: '河北省水利厅', value: '5' }
          ],
        },
        {
          text: '江苏省',
          value: '2',
          children: [{ text: '南京市', value: '6' }],
        },
      ],

      indexList: [],
      filterData:[], // 处理后的 待渲染数据      
      areaList:[],
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
      // 自定义登记表单（新活动）
      formFields: [],       // 字段定义（来自 info 接口）
      formData: {},         // 表单值 {field_name: value}
      regionText: {},       // 地区字段的显示文本 {field_name: 'xx/xx'}
      regionShow: {},       // 地区弹层显隐 {field_name: bool}
      regionOptions: {},    // 地区树 {field_name: [cascader options]}
      radioText: {},        // 单选(下拉)显示文本 {field_name: label}
      radioShow: {},        // 单选(下拉)弹层显隐 {field_name: bool}
    }
  },
  computed: {},
  watch: {},
  created () {
    this.platform = this.$route.query.platform;
    this.learnid = this.$route.query.learnid;
    this.token = this.$store.state.token;
    if(!this.token && this.learnid) {
      this.token = localStorage.getItem(this.learnid + '_token') || '';
    }
    this.openid = this.$store.state.openid;
    this.accessid = this.$store.state.accessid;
    this.accountId = this.$store.state.accountId;
    this.uniqueId = this.$store.state.uniqueId;
    this.actInfo = this.$store.state.actInfo;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.actInfo = this.$store.state.actInfo;
  },
  mounted() {
    if(this.actInfo.areaid>0) {
      this.getArea()
    }    
    this.loadFormFields();
    // zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);      
  },
  methods: {   
    setAreaid(row){
      console.log('row',row);
      this.areaid = row.value;
      this.area_name = row.text;
      this.showSelect = false;
    },
    areaData(){      
      // 安装使用 js-pinyin 插件，获取待处理字段的拼音
      const pinyin = require('js-pinyin');
      
      this.areaList.map(item => { item.pinyin = pinyin.getFullChars(item.text); });
      // console.log('this.areaList',this.areaList);
      let provice = {};          
      this.areaList.map((item) => {         
        const Initials = item.pinyin[0].toUpperCase();      
        // 如果对象里有当前字母项则直接 push 一个对象,如果没有则创建一个新的键并赋值;     
        if (provice[Initials]) {     
          provice[Initials].push(item);       
        } else {     
          provice[Initials] = [item];      
        }       
      });

      // 将数据转为数组，并按字母顺利排列
      this.filterData = [];  
      for(let key in provice) {
        const obj = { letter: key, list:provice[key] };
        // console.log('obj',obj);
        this.filterData.push(obj)
      }    
      this.filterData.sort((a,b) => { return a.letter.localeCompare(b.letter) });
      // 为索引字符数组赋值
      this.indexList = [];
      this.filterData.forEach(item => this.indexList.push(item.letter));
      // console.log('filterData',this.filterData)
    }, 
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.showSelect = false;
      this.area_name = selectedOptions.map((option) => option.region_name).join('/');
      if(selectedOptions.length>0){
        this.areaid = selectedOptions[selectedOptions.length-1].region_id;
      }else{
        this.areaid = selectedOptions[0].region_id;
      }      
    },
    async getArea() {
      let result = await reqArea({region_id:this.actInfo.areaid});
      this.options = result
    },
    // 加载自定义登记表单字段定义（来自 info 接口 form_fields）
    loadFormFields() {
      this.loadForm = true;
      reqLearnInfo({platform:this.platform, learnid:this.learnid}).then(res => {
        if (res.code == 200) {
          this.formFields = res.data.form_fields || [];
          this.initFormData();
          this.loadForm = false;
        }
      }).catch(() => {})
    },
    // 初始化表单值（默认值/回显值），并预载地区树
    initFormData() {
      const fd = {};
      const rt = {};
      const rs = {};
      const rtt = {};
      const rsh = {};
      this.formFields.forEach(f => {
        let def = '';
        if (f.type === 'checkbox') {
          let arr = [];
          try {
            const d = JSON.parse(f.default_value);
            arr = Array.isArray(d) ? d : (d ? [d] : []);
          } catch (e) {
            arr = f.default_value ? [f.default_value] : [];
          }
          def = arr;
        } else {
          def = f.default_value || '';
        }
        fd[f.model] = def;
        rt[f.model] = '';
        rs[f.model] = false;
        if (f.type === 'region') {
          this.getRegionOptions(f);
        }
        if (f.type === 'radio' && (f.display_type === 'select' || f.display_type === 'index')) {
          rtt[f.model] = this.optionLabel(f, def);
          rsh[f.model] = false;
        }
      });
      this.formData = fd;
      this.regionText = rt;
      this.regionShow = rs;
      this.radioText = rtt;
      this.radioShow = rsh;
    },
    // 根据选项 value 取 label
    optionLabel(f, val) {
      const opt = (f.options || []).find(o => String(o.value) === String(val));
      return opt ? opt.label : '';
    },
    // 根据当前值取选项下标（用于下拉框默认定位）
    optionIndex(f) {
      const idx = (f.options || []).findIndex(o => String(o.value) === String(this.formData[f.model]));
      return idx >= 0 ? idx : 0;
    },
    // 下拉框选择完成
    onRadioConfirm(f, idx) {
      this.radioShow[f.model] = false;
      const opt = (f.options || [])[idx];
      if (opt) {
        this.$set(this.formData, f.model, opt.value);
        this.$set(this.radioText, f.model, opt.label);
      }
    },
    // 单选"首字母索引"分组数据（按选项名称首字母，类似通讯录）
    radioIndexData(f) {
      const pinyin = require('js-pinyin');
      const groups = {};
      (f.options || []).forEach(opt => {
        const label = opt.label || '';
        if (!label) return;
        let letter = '#';
        const ch = label.charAt(0);
        if (/[a-zA-Z]/.test(ch)) {
          letter = ch.toUpperCase();
        } else if (/[\u4e00-\u9fa5]/.test(ch)) {
          const py = pinyin.getFullChars(ch) || '';
          letter = py ? py.charAt(0).toUpperCase() : '#';
        }
        if (!groups[letter]) groups[letter] = [];
        groups[letter].push(opt);
      });
      const filterData = Object.keys(groups).sort((a, b) => {
        if (a === '#') return 1;
        if (b === '#') return -1;
        return a.localeCompare(b);
      }).map(letter => ({ letter, list: groups[letter] }));
      return { filterData, indexList: filterData.map(g => g.letter) };
    },
    // 首字母索引选中
    onRadioIndexSelect(f, opt) {
      this.radioShow[f.model] = false;
      this.$set(this.formData, f.model, opt.value);
      this.$set(this.radioText, f.model, opt.label);
    },
    // 获取地区联动菜单数据
    getRegionOptions(f) {
      const params = { platform: this.platform, learnid: this.learnid };
      if (f.region_id) {
        params.region_id = f.region_id;
      }
      reqRegion(params).then(res => {
        if (res.code == 200) {
          this.$set(this.regionOptions, f.model, res.data || []);
        }
      }).catch(() => {})
    },
    // 地区选择完成
    onRegionFinish(f, { selectedOptions }) {
      this.regionShow[f.model] = false;
      const names = (selectedOptions || []).map(o => o.text).join('/');
      this.$set(this.regionText, f.model, names);
      if (selectedOptions && selectedOptions.length > 0) {
        this.$set(this.formData, f.model, selectedOptions[selectedOptions.length - 1].value);
      }
    },
    // 客户端校验自定义表单必填项
    validateFormData() {
      for (let i = 0; i < this.formFields.length; i++) {
        const f = this.formFields[i];
        if (!f.required) continue;
        const v = this.formData[f.model];
        const empty = v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0);
        if (empty) {
          this.$toast({ icon: 'warning-o', message: f.label + '为必填项' });
          return false;
        }
      }
      return true;
    },
    async onSubmit(values) { //表单提交
      console.log('submit', values);
      // 自定义表单客户端校验
      if (this.formFields.length > 0 && !this.validateFormData()) {
        return;
      }
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }  
      if(this.platform == 1 || this.platform == 5){
          data.token = this.token;
      }
      // 自定义登记表单数据
      if (this.formFields.length > 0) {
        data.form_data = JSON.stringify(this.formData);
      }

      reqUserAdd({...values,...data}).then(res => {
          if(res.code==200) {
              localStorage.clear(); //清空本地观看记录
              Cookies.set('ckplayer-player-cookie','');
              this.$router.push({ path: '/list',query:this.$route.query })  //直接进入课程列表页       
          } else {
              this.$toast({
                icon: 'success-o',
                message: res.msg
              });
          }
          
      }).catch(() => {
          this.loading = false
      }) 
    },
    noticeBox(){ //显示活动须知弹窗
      this.showNotice = true;
    },
    kefuBox(){ //显示客服弹窗
      this.showKefu = true;
    },
    toHome(){
      this.$router.push({ path: '/list',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    }
  },
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 600px;
    min-height:480px;    
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 380px;    
    background: #fff;
    border-radius: 20px;
    padding:80px 50px;
    padding-top: 80px;

    .subBtn{ margin:0px; margin-top:50px;}
    .van-button{ background: var(--styleColor); border: 0px; border-radius: 15px;}
    .huodong{ padding-right: 15px; margin-right:20px; border-right: 2px solid #e7e8e8;}
    .van-cell{ border:2px solid #e7e8e8; padding:12px 15px; margin-bottom: 30px; border-radius: 10px;}
    .van-cell::after{ border:0px;}

    .areaBox{
      overflow: hidden;
      .indexBody{ height: 100%; overflow-y: auto; -webkit-overflow-scrolling: touch; }
      .van-cell{ border:0px; margin:0px 15px; margin-bottom: 10px; border-radius: 0px;}
      .van-index-anchor{ font-weight: bold;}
    }
    .phoneBox{
      padding: 4px 5px 4px 15px;
    }
    ::v-deep .van-index-bar__index{
      padding: 10px 20px;
      font-size: 26px;
    }
    ::v-deep .van-field__left-icon{
      display: flex;
      align-items: center;      
    }

  }
::v-deep .van-popup{

}
  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }
  




  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  }

}
</style>
